import { all, takeLatest } from 'redux-saga/effects'

import { companyApi } from '../../../services/'
import {
  createCompanyRequest,
  getCompanyDetailRequest,
  getCompanyListRequest,
  getCompanyStatusStatisticsRequest,
  updateCompanyRequest,
  updateCompanyStatusRequest
} from '../actions'
import { createCompanySaga } from './createCompany'
import { getCompanyDetailSaga } from './getCompanyDetail'
import { getCompanyListSaga } from './getCompanyList'
import { getCompanyStatisticsSaga } from './getCompanyStatistics'
import { updateCompanySaga } from './updateCompany'
import { updateCompanyStatusSaga } from './updateCompanyStatus'

export function* companySaga() {
  try {
    yield all([
      takeLatest(
        getCompanyStatusStatisticsRequest as any,
        getCompanyStatisticsSaga,
        companyApi
      ),
      takeLatest(getCompanyListRequest as any, getCompanyListSaga, companyApi),
      takeLatest(
        getCompanyDetailRequest as any,
        getCompanyDetailSaga,
        companyApi
      ),
      takeLatest(createCompanyRequest as any, createCompanySaga, companyApi),
      takeLatest(updateCompanyRequest as any, updateCompanySaga, companyApi),
      takeLatest(
        updateCompanyStatusRequest as any,
        updateCompanyStatusSaga,
        companyApi
      )
    ])
  } catch (err) {
    // TODO: handle error
  }
}
